export default {
    'name': 'chairman-ru',
    'width': '32',
    'height': '32',
    'viewBox': '0 0 32 32',
    'data': '<path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32ZM9.87402 23V8.89999H22.134V23H19.574V11.04H12.434V23H9.87402Z\' fill=\'#026958\'/>'
}
